export class APIEndPoints {
  // Import students
  static saveImportStudents = '/api/StudentImportFields/ImportStudents';
  static GetClientTilesPermissions = `/api/Authorization/GetClientTilesPermissions?username=`;
  static getEmailTemplatesData = `/api/EmailNotifications/GetEmailTemplatesData`;
  static getAllEmailTemplates = `/api/EmailNotifications/GetAllEmailTemplates`;
  static getWaiverCardsByClientId = `/api/EmailNotifications/GetWaiverActiveCardsByClientId?clientId=`;
  static getBulkEmailRecipient = `/api/BulkEmail/GetBulkEmailRecipient?bulklListId=`;
  static getStudentsReceivingEmails = `/api/Students/GetBulkEmailNotificationByStudentCriteria`;
  static saveAndSubmitEmailNotificationsCriteria = `/api/BulkEmail/SubmitBulkEmailNotification`;
  static getEmailList = `/api/BulkEmailList/GetEmailList?clientId=`;
  static viewBulkEmailListById = `/api/BulkEmailList/ViewBulkEmailNotification?listId=`;
  static getWaiverMgtPolicyConfiguration = `/api/Reports/GetWaiverMgtPolicyConfiguration`;
  static getWaiverMgtConfiguration = `/api/Reports/GetWaiverMgtAdminWaivers`;
  static getThirdPartyVerificationEnabledClientIds = `/api/Clients/GetThirdPartyVerificationEnabledClientIds`;
  static getAppealEnabledClientIds = `/api/Clients/GetAppealEnabledClientIds`;
  static getWaiverAppealsReport = `/api/Reports/WaiverAppeals`;
  static getStudentDemographicsReport = `/api/Reports/SearchForRewrite`;
  static getStubmittedWaiverReport = `/api/Reports/GetSubmittedWaiverForms`;
  static getSubmittedEnrollmentsReport = `/api/Reports/GetSubmittedEnrollmentsorStudentCoverages`;
  static getStudentsTakingNoActionReport = `/api/Reports/GetStudentsTakingNoAction`;
  static getApproveCoverageHistory = `/api/Reports/GetApproveCoverageHistory?clientNumber=`;
  static getApproveCoverageHistoryReport = `/api/Reports/GetApproveCoverageHistoryReport?transHeaderId=`;
  static getUserDetails = `/api/Authorization/GetUserDetails?uuid=`;
  static getMyAccountToken = `/api/Account/GetMyAccountToken`;
  static getPermissionsWithClients = `/api/Authorization/GetPermissionsWithClients?username=`;
  static getReferralDataById = `/api/Referral/Get/`;
  static getVendorList = `/api/Authorization/GetVendors`;
  static generateMyAccountUri = `/api/Account/GenerateMyAccountUri`;
  static searchReviewAcceptedClaims = `/api/Claim/SearchReviewAcceptedClaims`;
  static getFieldRequirementsGrid = `/api/Claim/GetFieldRequirements`;
  static downloadAcceptedClaims = `/api/Claim/DownloadAcceptedClaims`;
  static getLedgerClaimStatuses = `/api/LedgerBilling/GetLedgerClaimStatuses`;
  static searchClaims = `/api/Claim/SearchClaims`;
  static getClaimById = `/api/Claim/GetClaimById/`;
  static acceptClaim = '/api/Claim/AcceptClaim';
  static downloadSearchClaims = `/api/Claim/DownloadSearchClaims`;
  static getHeldClaims = `/api/LedgerBilling/GetHeldClaims`;
  static denyClaims = `/api/Claim/DenyClaims`;
}
